import { signalOrValueRef } from '../../common';
import { midPoint } from './valueref';
export function positionOffset(_ref) {
  var baseChannel = _ref.channel,
      markDef = _ref.markDef,
      _ref$encoding = _ref.encoding,
      encoding = _ref$encoding === void 0 ? {} : _ref$encoding,
      model = _ref.model,
      bandPosition = _ref.bandPosition;
  var channel = "".concat(baseChannel, "Offset"); // Need to cast as the type can't be inferred automatically

  var defaultValue = markDef[channel];
  var channelDef = encoding[channel];

  if ((channel === 'xOffset' || channel === 'yOffset') && channelDef) {
    var ref = midPoint({
      channel: channel,
      channelDef: channelDef,
      markDef: markDef,
      config: model === null || model === void 0 ? void 0 : model.config,
      scaleName: model.scaleName(channel),
      scale: model.getScaleComponent(channel),
      stack: null,
      defaultRef: signalOrValueRef(defaultValue),
      bandPosition: bandPosition
    });
    return {
      offsetType: 'encoding',
      offset: ref
    };
  }

  var markDefOffsetValue = markDef[channel];

  if (markDefOffsetValue) {
    return {
      offsetType: 'visual',
      offset: markDefOffsetValue
    };
  }

  return {};
}